export default __webpack_public_path__ + "static/media/Fury of the Sleeping Stars.d48d98ab.jpg";